<div class="mona-user-settings">
    <router-outlet></router-outlet>
</div>
